import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { AvailableLanguages } from '@constants';
import { AllDeviceInfo } from '@interfaces';
import { TranslateService } from '@ngx-translate/core';
import { DeviceInfoService } from '@core/services/device-info.service';
import { ReplaySubject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-insurance-banner',
  templateUrl: './insurance-banner.component.html',
  styleUrls: ['./insurance-banner.component.scss'],
  standalone: false,
})
export class InsuranceBannerComponent implements OnInit, OnDestroy {
  private readonly translateService = inject(TranslateService);
  private readonly deviceInfoService = inject(DeviceInfoService);

  private readonly destroy$: ReplaySubject<boolean> = new ReplaySubject(1);

  public userLang: AvailableLanguages;
  public LINK_TARGET: string;
  public deviceTypeDetected: AllDeviceInfo['deviceTypeDetected'];
  public mobileDisclaimerExpanded = false;
  public mobileDisclaimerWasRevealed = false;

  public ngOnInit(): void {
    this.userLang = this.translateService.currentLang as AvailableLanguages;
    this.LINK_TARGET = this.translateService.instant('INSURANCE_BANNER.URL');
    this.deviceTypeDetected = this.deviceInfoService.getInfo().deviceTypeDetected;

    this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(({ lang: langKey }) => {
      this.userLang = langKey as AvailableLanguages;
      this.LINK_TARGET = this.translateService.instant('INSURANCE_BANNER.URL');
    });

    this.deviceInfoService.infoEmitter.pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.deviceTypeDetected = info.deviceTypeDetected;
      if (this.deviceTypeDetected !== 'PHONE') {
        this.mobileDisclaimerExpanded = false;
      }
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public openTargetInNewPage(): void {
    window.open(this.LINK_TARGET, '_blank').focus();
  }

  public toggleMobileDisclaimer(): void {
    this.mobileDisclaimerExpanded = !this.mobileDisclaimerExpanded;

    if (this.mobileDisclaimerExpanded) {
      this.mobileDisclaimerWasRevealed = true;
    }
  }
}
